export enum SaleChannelPlatformTypes {
  None = 'None',
  Ios = 'iOS',
  Android = 'Android',
}
